'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-surveys/static/vendor/vue.js'], function (Vue) {
	Vue.component('question-edit-answers', {
		props: ['question', 'initData'],
		template:
		'<div>' +
			'<h5 class="mb-2">{{initData.translations.answers}}</h5>' +
			'<div class="list-group answers-editor">' +
				'<div class="row" v-for="answer in question.answers">' +
					'<div class="col-xs-1 text-right" style="padding: 7px 0">{{answer.weight}}.</div>' +
					'<div class="col-xs-11">' +
						'<input class="form-control" type="text" v-model="answer.label" :placeholder="initData.translations.answersLabelPlaceholder" />' +
					'</div>' +
				'</div>' +
			'</div>' +
		'</div>',
	});
});
